"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const context_1 = require("../../context");
exports.OsmosysFormInput = (props) => {
    const { data, onFieldChange } = context_1.useOsmosysForm();
    return (react_1.default.createElement(reactstrap_1.Input, { value: data[props.name], onChange: e => {
            onFieldChange(props.name, e.target.value);
        } }));
};
//# sourceMappingURL=OsmosysFormInput.js.map